import {Link} from 'react-router';
import {Table, Popover} from 'antd';
import {TrashWidget} from "../widget/TrashWidget";
import {PurchaseOrderItemStatusWidget} from "../widget/PurchaseOrderItemStatusWidget";
import {InventoryAssignmentWidget} from "../fulfillment/InventoryAssignmentWidget";
import {toUtcDateStringShort} from "../../util/timeutils";

export const PurchaseOrderLineItemTable = ({purchaseId, products, onDelete, onSelectAssign, onApiFail, refresh, onRefresh, isFulfillment=false, showLink=false, showState=false, props}) => {
    const onRowDelete = (index) => () => {
        if (onDelete) {
            onDelete(index, products[index]);
        }
    }

    const onAssignmentSelect = (index) => (val) => {
        if (onSelectAssign) {
            onSelectAssign(val, index);
        }
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                if (showLink === true) {
                    return <Link to={`/purchaseorder/${purchaseId}/lineItem/${record.id}`}>{val}</Link>
                }
                return val;
            }
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity'
        },
    ];

    if (showState) {
        columns.push({
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                return <PurchaseOrderItemStatusWidget item={record} onApiFail={onApiFail} onRefresh={onRefresh} isFulfillment={isFulfillment}/>
            }
        })

        columns.push({
            title: 'Inventory',
            dataIndex: 'inventoryId',
            key: 'inventoryId',
            render: (val, record, index) => {
                if (val !== null) {
                    return <Popover content={`Inventory Created by Fulfillment for this Purchase Order`}>Completed</Popover>
                } else {
                    return <InventoryAssignmentWidget productId={record.productId} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} onSelect={onAssignmentSelect(index)}/>
                }
            }
        })
    }

    if (onDelete !== undefined) {
        columns.push({
            title: 'Delete',
            dataIndex: 'name',
            key: 'delete',
            render: (val, record, index) => {
                const {completed, completedByUser} = record;
                if (completedByUser) {
                    return <div>{`completed by ${completedByUser} on ${toUtcDateStringShort(new Date(completed))}`}</div>
                }

                return <TrashWidget onDelete={onRowDelete(index)} />
            }
        });
    }

    return <Table dataSource={products} columns={columns} pagination={false} />
}